import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import { useLocation } from 'react-router-dom';

function Single() {
    const location = useLocation();
    const [postData, setPostData] = useState(null);
    
    // Parse the URL query parameters to get the post ID
    useEffect(() => {
        const searchParams = new URLSearchParams(location.search);
        const postId = searchParams.get('id') || 'sequence-kx'; // Default to first post if no ID
        
        // Fetch or set the post data based on the ID
        const posts = {
            'sequence-kx': {
                title: 'SEQUENCE by KX',
                date: 'October 28, 2020',
                author: 'Kx__',
                presenter: 'Suburbs Gallery Highlights',
                image: 'https://f8n-production.imgix.net/worlds/zkeny1rmr.jpg?q=70&cs=srgb&max-w=720&max-h=720&fit=fill&dpr=2&fnd_key=v1',
                content: `
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam at felis fringilla, pulvinar nulla ac, elementum nibh. Mauris efficitur dui at molestie tincidunt. Sed eget metus ligula.</p>
                    <p>Vestibulum ante ipsum primis in faucibus orci luctus et ultrices posuere cubilia curae; Etiam non commodo elit. Vivamus tempor ligula a eros euismod, a sollicitudin nibh commodo.</p>
                    <blockquote class="mb30">"The digital artist finds freedom in the transitory nature of their medium, forever undoing and recreating the world pixel by pixel, unbound by physical constraints."</blockquote>
                    <h3 class="mb20">About the Exhibition</h3>
                    <p>SEQUENCE explores the relationship between algorithmic processes and human creativity, showcasing Kx's distinctive visual language through a series of digital artworks that evolve and respond to viewer interaction.</p>
                `
            },
            'deconstructed': {
                title: 'DECONSTRUCTED',
                date: 'October 28, 2020',
                author: 'blanq, Jess Mac, and 14 others',
                presenter: 'MAIF',
                image: 'https://f8n-production.imgix.net/worlds/t2c1k0rfu.jpg?q=70&cs=srgb&max-w=720&max-h=720&fit=fill&dpr=2&fnd_key=v1',
                content: `
                    <p>Aliquam erat volutpat. Aenean sed feugiat nibh. Pellentesque habitant morbi tristique senectus et netus et malesuada fames ac turpis egestas. Proin ultrices felis ut magna interdum, at luctus enim condimentum.</p>
                    <p>Integer accumsan nunc et justo faucibus, sit amet finibus felis rutrum. Nulla facilisi. Vivamus sagittis, tortor ac sodales consectetur, ex nibh condimentum velit.</p>
                    <blockquote class="mb30">"Deconstruction is not simply taking things apart; it is understanding the inherent contradictions in how meaning is constructed."</blockquote>
                    <h3 class="mb20">Exhibition Details</h3>
                    <p>DECONSTRUCTED brings together 16 diverse artists exploring the fragmentation of digital identity, form, and narrative. Through interactive installations and generative artworks, this exhibition challenges viewers to reconsider their relationship with technology and digital representation.</p>
                `
            }
        };
        
        setPostData(posts[postId] || posts['sequence-kx']);
    }, [location]);
    
    if (!postData) return <div>Loading...</div>;
    
    return (
        <div id="wrapper">
            {/* Header component */}
            <Header />

            <div className="no-bottom no-top" id="content">
                <div id="top"></div>

                {/* section begin */}
                <section id="subheader" className="minimal">
                    <div className="center-y relative text-center">
                        <div className="container">
                            <div className="row">
                                <div className="col-md-12 text-center">
                                    <h1>Exhibitions</h1>
                                </div>
                                <div className="clearfix"></div>
                            </div>
                        </div>
                    </div>
                </section>                
                {/* section close */}

                {/* section begin */}
                <section aria-label="section" style={{ paddingTop: 0 }}>
                    <div className="container">
                        <div className="row justify-content-center text-center wow fadeIn">
                            <div className="spacer-40"></div>

                            <div className="col-lg-8 col-md-10">
                                <div className="post-image-single">
                                    <img src={postData.image} id="click_banner_img" className="d-banner-img-edit img-fluid" alt={postData.title} />
                                </div>
                                <div className="post-text">
                                    <span className="p-date">{postData.date}</span>
                                    <h4><a href="#">{postData.title}<span></span></a></h4>
                                    <p>{postData.author}
                                        <br />Presented by {postData.presenter}
                                    </p>
                                    <div className="spacer-40"></div>
                                </div>
                                <div className="post-body text-left" style={{ fontSize: '18px', lineHeight: '1.8', color: '#000' }}>
                                    <div dangerouslySetInnerHTML={{ __html: postData.content }} />
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            {/* Footer */}
            <Footer />
        </div>
    );
}

export default Single;